// extracted by mini-css-extract-plugin
export default {"container":"uM-z","modal":"vM-z","dimensions":"wM-z","brandName":"xM-z","productName":"yM-z","labelValue":"zM-z","recipientEmail":"AM-z","recommendedFit":"BM-z","hiddenField":"CM-z"};